import { render, staticRenderFns } from "./Workspace.vue?vue&type=template&id=0a0a5ae1&scoped=true&"
import script from "./Workspace.vue?vue&type=script&lang=js&"
export * from "./Workspace.vue?vue&type=script&lang=js&"
import style0 from "./Workspace.vue?vue&type=style&index=0&id=0a0a5ae1&prod&lang=scss&"
import style1 from "./Workspace.vue?vue&type=style&index=1&id=0a0a5ae1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a5ae1",
  null
  
)

export default component.exports